import { render, staticRenderFns } from "./EntryFrame.vue?vue&type=template&id=2ca9ce3e&"
import script from "./EntryFrame.vue?vue&type=script&lang=js&"
export * from "./EntryFrame.vue?vue&type=script&lang=js&"
import style0 from "./EntryFrame.vue?vue&type=style&index=0&id=2ca9ce3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports